import React, { useCallback, useEffect, useState } from "react";
import { Layout } from "../../components/layout/Layout";
import { PageHeader } from "../../components/layout/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { dismissCommunicationAlert, listTeacherCommunicationAlerts } from "../../services/api/communicationLearning";

type AlertRow = { id?: string; student_id?: string; reason?: string; severity?: string; created_at?: string };

export default function CommunicationAlertsPage() {
  const [items, setItems] = useState<AlertRow[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await listTeacherCommunicationAlerts();
      setItems((r.items as AlertRow[]) ?? []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <Layout>
      <PageHeader title="Communication alerts" subtitle="Students who may need extra support." />
      <div className="max-w-3xl mx-auto px-4 py-8 space-y-4">
        <Button variant="outline" size="sm" onClick={() => void load()}>
          Refresh
        </Button>
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Open alerts</CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <p className="text-slate-500 text-sm">Loading…</p>
            ) : items.length === 0 ? (
              <p className="text-slate-500 text-sm">No open alerts.</p>
            ) : (
              <ul className="space-y-2">
                {items.map((a) => (
                  <li
                    key={a.id ?? `${a.student_id}-${a.reason}`}
                    className="flex flex-wrap items-center justify-between gap-2 p-3 rounded-xl border border-amber-100 bg-amber-50/60"
                  >
                    <div className="text-sm">
                      <span className="font-medium text-slate-900">{a.reason}</span>
                      <span className="text-slate-600 ml-2">student {a.student_id}</span>
                      <span className="text-slate-500 ml-2">{a.severity}</span>
                    </div>
                    {a.id ? (
                      <Button variant="outline" size="sm" onClick={() => dismissCommunicationAlert(a.id!).then(() => load())}>
                        Dismiss
                      </Button>
                    ) : null}
                  </li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
